import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Menu, X, Flame } from "lucide-react";
import { CONTACTS } from "@/data/content";

const nav = [
  { to: "/#servizi", label: "Servizi" },
  { to: "/#chi-siamo", label: "Chi Siamo" },
  { to: "/#galleria", label: "Galleria" },
  { to: "/fotovoltaico", label: "Pulizia Fotovoltaico" },
  { to: "/#zone", label: "Zone Servite" },
  { to: "/#contatti", label: "Contatti" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md"
      style={{
        backgroundColor: "rgba(11, 9, 6, 0.88)",
        borderBottom: "1px solid var(--border-gold)",
      }}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <div
            className="w-11 h-11 rounded-xl flex items-center justify-center relative overflow-hidden"
            style={{
              background: "linear-gradient(180deg, #1B1712 0%, #0B0906 100%)",
              border: "1px solid var(--gold)",
              boxShadow: "0 0 20px rgba(227, 106, 44, 0.3), inset 0 0 12px rgba(227, 106, 44, 0.15)",
            }}
          >
            <Flame
              size={22}
              className="flame-flicker"
              style={{ color: "var(--ember)", fill: "rgba(247, 199, 68, 0.4)" }}
            />
          </div>
          <div className="leading-tight">
            <div
              className="font-semibold text-[1.05rem] gold-text"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Spazzacamino Davide
            </div>
            <div className="text-xs" style={{ color: "var(--text-muted)" }}>
              Modena · Bologna · Reggio Emilia
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {nav.map((n) => (
            <a
              key={n.to}
              href={n.to}
              className="text-sm font-medium hover:text-[var(--gold-bright)] transition-colors"
              style={{ color: "var(--text-primary)" }}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href={`tel:${CONTACTS.phoneRaw}`}
            className="btn-ghost !py-2 !px-4 text-sm"
            data-testid="header-call-btn"
          >
            <Phone size={16} />
            {CONTACTS.phoneDisplay}
          </a>
          <a
            href={`https://wa.me/${CONTACTS.whatsapp}?text=${encodeURIComponent(CONTACTS.whatsappMsg)}`}
            target="_blank"
            rel="noreferrer"
            className="btn-whatsapp !py-2 !px-4 text-sm"
            data-testid="header-whatsapp-btn"
          >
            <MessageCircle size={16} />
            WhatsApp
          </a>
        </div>

        <button
          className="lg:hidden p-2"
          style={{ color: "var(--gold-bright)" }}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t"
          style={{ borderColor: "var(--border-gold)", backgroundColor: "var(--bg-primary)" }}
          data-testid="mobile-menu"
        >
          <div className="px-5 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <a
                key={n.to}
                href={n.to}
                className="py-2 font-medium"
                style={{ color: "var(--text-primary)" }}
                onClick={() => setOpen(false)}
              >
                {n.label}
              </a>
            ))}
            <div className="flex gap-2 pt-2">
              <a href={`tel:${CONTACTS.phoneRaw}`} className="btn-primary flex-1 justify-center">
                <Phone size={16} /> Chiama
              </a>
              <a
                href={`https://wa.me/${CONTACTS.whatsapp}?text=${encodeURIComponent(CONTACTS.whatsappMsg)}`}
                target="_blank"
                rel="noreferrer"
                className="btn-whatsapp flex-1 justify-center"
              >
                <MessageCircle size={16} /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
